import { Button } from '@shinetools/lumen-react'
import { Check, Copy } from 'lucide-react'
import { FC, useCallback, useRef, useState } from 'react'
import { useCopyToClipboard } from 'react-use'

interface CopySettingsButtonProps {
  textToCopy: string
}

const CopySettingsButtonCheckDisplayTimeoutMillis = 700

export const CopySettingsButton: FC<CopySettingsButtonProps> = ({ textToCopy }) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [hasCopied, setHasCopied] = useState(false)
  const [, copy] = useCopyToClipboard()

  const handleCopyButtonClick = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    copy(textToCopy)
    setHasCopied(true)

    timerRef.current = setTimeout(() => {
      setHasCopied(false)
    }, CopySettingsButtonCheckDisplayTimeoutMillis)
  }, [copy, setHasCopied, textToCopy])

  return <Button size="large" variant="text" icon={hasCopied ? <Check /> : <Copy />} onClick={handleCopyButtonClick} />
}
